import axios from 'axios';
import { message } from 'antd';
import { saveFile } from '@/utils/helper/base';

// 按状态码映射的兜底提示;
const ERROR_TIPS: Record<number, string> = {
  403: '无权限',
  404: '报告原始文件不存在',
  429: '操作过于频繁，请稍后再试',
  500: '报告原始文件下载失败，请稍后重试',
};

// 优先取 filename*（RFC 5987，含中文），兜底 filename=（去掉中文的 ASCII 兜底名）
function parseContentDispositionFilename(header = ''): string {
  const star = header.match(/filename\*\s*=\s*(?:[^']*'[^']*')?([^;]+)/i);
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1].trim().replace(/^"|"$/g, ''));
    } catch { /* 解码失败则走 filename 兜底 */ }
  }
  const plain = header.match(/filename\s*=\s*"?([^";]+)"?/i);
  return plain?.[1]?.trim() || '报告原始文件';
}

// 下载报错需按下载场景提示，不走全局拦截器（其对 404 重定向、对 500 有全局文案）
async function showDownloadError(err: any) {
  const { response } = err;
  if (!response) {
    message.error('网络异常，请稍后重试');
    return;
  }
  // responseType: 'blob' 时错误响应体也是 Blob，需手动解析出错误详情
  let detail = '';
  try {
    const json = JSON.parse(await response.data.text());
    detail = json?.errors?.detail;
  } catch { /* 非 JSON 错误体，忽略 */ }
  message.error(ERROR_TIPS[response.status] || detail || '下载失败，请稍后重试');
}

/**
 * 下载报告原始文件
 * 不走共享 request 实例：其响应拦截器会丢弃 headers（拿不到 Content-Disposition 中的文件名）
 * @param path 导出接口路径（如 /api/adminapi/report/exportRawFile/xxx）
 * @param headers 附加请求头（专区后台需传 szid）
 */
export default async function downloadReportRawFile(path: string, headers: Record<string, string> = {}) {
  let res;
  try {
    res = await axios.get(path, {
      baseURL: process.env.REACT_APP_SERVER_BASE,
      withCredentials: true,
      responseType: 'blob',
      timeout: 0, // 不限时：文件可能很大（网页报告 zip 上限 1G），限时会掐断慢网下载
      headers,
    });
  } catch (err) {
    await showDownloadError(err);
    return;
  }

  saveFile(res.data, parseContentDispositionFilename(res.headers['content-disposition']));
}
